import request from "./request";
const api = {
  getCurrencyList: 'chain/getCurrencyList',
  getCurrencyItemList: 'chain/getCurrencyItemList'
}

export default {
  getCurrencyList(parameter) {
    return request({
      url: api.getCurrencyList,
      method: 'post',
      data: parameter
    })
  },
  getCurrencyItemList(parameter) {
    return request({
      url: api.getCurrencyItemList,
      method: 'post',
      data: parameter
    })
  }
}
